import styled from 'styled-components';
import { getThemeColor, getThemeTypography } from 'utils/styled';
import { LIST_ITEM_SPACING_PX } from '../constants';
import { MenuListItemStyleProps } from './types';

const defaultStyles = `
  height: 50px;
  padding-top: 5px;
  padding-bottom: 5px;
`;

const comfortableStyles = `
  padding-top: 0px;
  padding-bottom: 0px;
`;

const densityStyles = {
  default: defaultStyles,
  compact: {},
  comfortable: comfortableStyles,
};

const innerContainerCompact = `
  padding: 8px;
`;

const innerContainerDensityStyles = {
  default: {},
  comfortable: {},
  compact: innerContainerCompact,
};

const iconCompact = `
  margin-right: 8px;
  width: 30px;
`;

const iconDensityStyles = {
  default: {},
  comfortable: {},
  compact: iconCompact,
};

export const MenuListItemRoot = styled.li<MenuListItemStyleProps>`
  && {
    ${getThemeTypography('h2')};
    align-items: center;
    cursor: pointer;
    display: flex;
    font-weight: normal;
    outline: none;

    ${({ $density }) => densityStyles[$density]}

    transition: ${({ theme }) =>
      theme.transitions.create('background-color', '100ms')};
  }
`;

export const ItemInnerContainer = styled.div<MenuListItemStyleProps>`
  align-items: center;
  border-radius: 8px;
  display: flex;
  padding: 10px ${LIST_ITEM_SPACING_PX}px;
  width: 100%;

  ${MenuListItemRoot}[data-hovered='true'] &,
  ${MenuListItemRoot}[data-focused='true'] &,
  ${MenuListItemRoot}[aria-selected='true'] & {
    background-color: ${getThemeColor('l3')};
  }

  ${({ $density }) => innerContainerDensityStyles[$density]}
`;

export const IconContainer = styled.div<MenuListItemStyleProps>`
  display: flex;
  color: ${getThemeColor('d5')};
  justify-content: center;
  margin-right: 16px;
  width: 14px;

  ${({ $density }) => iconDensityStyles[$density]}
`;
